// app/javascript/controllers/floating_image_grid_controller.js

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "image", "grid"]

  connect() {
    this.isDragging = false
    this.startX = 0
    this.startY = 0
    this.scrollLeft = 0
    this.scrollTop = 0
    this.animationInterval = null
    this.lastTime = 0
    this.velocity = { x: 0, y: 0 }

    this.startAnimation()
    this.setupGrid()
  }

  disconnect() {
    this.stopAnimation()
  }

  setupGrid() {
    const imageCount = this.imageTargets.length
    const rowCount = Math.ceil(imageCount / 10)
    this.gridTarget.style.width = `${10 * 200}px`
    this.gridTarget.style.height = `${rowCount * 200}px`
  }

  startAnimation() {
    this.animationInterval = setInterval(() => {
      this.imageTargets.forEach((img, index) => {
        const offsetX = Math.sin(Date.now() / 1000 + index) * 5
        const offsetY = Math.cos(Date.now() / 1000 + index) * 5

        // Save the animation translation as a data attribute
        // img.dataset.translate = `translate(${offsetX}px, ${offsetY}px)`

        // Combine tilt and animation transforms
        const tilt = img.dataset.tilt || ''
        const translate = `translate(${offsetX}px, ${offsetY}px)`

        img.style.transform = `${tilt} ${translate}`
      })
    }, 50)
  }

  stopAnimation() {
    if (this.animationInterval) {
      clearInterval(this.animationInterval)
    }
  }

  handleMouseDown(event) {
    if (event.button !== 0) return // Only respond to left mouse button
    this.isDragging = true
    this.startX = event.pageX - this.containerTarget.offsetLeft
    this.startY = event.pageY - this.containerTarget.offsetTop
    this.scrollLeft = this.containerTarget.scrollLeft
    this.scrollTop = this.containerTarget.scrollTop
    this.lastTime = Date.now()
    this.velocity = { x: 0, y: 0 }
    event.preventDefault() // Prevent text selection
  }

  handleMouseLeave() {
    this.isDragging = false
  }

  handleMouseUp() {
    this.isDragging = false
  }

  handleMouseMove(event) {
    if (!this.isDragging) return
    event.preventDefault()
    const x = event.pageX - this.containerTarget.offsetLeft
    const y = event.pageY - this.containerTarget.offsetTop
    const dx = x - this.startX
    const dy = y - this.startY
    this.containerTarget.scrollLeft = this.scrollLeft - dx
    this.containerTarget.scrollTop = this.scrollTop - dy

    // Update velocity
    const now = Date.now()
    const dt = now - this.lastTime
    this.velocity = {
      x: dx / dt,
      y: dy / dt
    }
    this.lastTime = now
  }

  handleWheel(event) {
    event.preventDefault()
    const scrollSpeed = 1
    this.containerTarget.scrollLeft += event.deltaX * scrollSpeed
    this.containerTarget.scrollTop += event.deltaY * scrollSpeed
  }

  handleImageClick(event) {
    const link = event.currentTarget.dataset.link
    window.open(link, '_blank')
  }

  handleImageEnter(event) {
    const img = event.currentTarget
    const rect = img.getBoundingClientRect()
    img.centerX = rect.left + rect.width / 2
    img.centerY = rect.top + rect.height / 2

    img.addEventListener('mousemove', this.tiltImage)
    img.addEventListener('mouseleave', this.resetTilt)
  }

  handleImageLeave = (event) => {
    const img = event.currentTarget
    img.removeEventListener('mouseenter', this.tiltImage)
    img.removeEventListener('mouseleave', this.resetTilt)
    this.resetTilt(event)
  }

  tiltImage = (event) => {
    const img = event.currentTarget
    const imgRect = img.getBoundingClientRect()
    const mouseX = event.clientX - imgRect.left
    const mouseY = event.clientY - imgRect.top
    const tiltX = (mouseY / imgRect.height - 0.5) * -50
    const tiltY = (mouseX / imgRect.width - 0.5) * 50

    // Save the tilt transform as a data attribute
    img.dataset.tilt = `perspective(1000px) rotateX(${tiltX}deg) rotateY(${tiltY}deg) scale3d(1.05, 1.05, 1.05)`

    // Combine tilt and animation transforms
    // const tilt = img.dataset.tilt || ''
    // const translate = img.dataset.translate || ''

    // img.style.transform = `${tilt} ${translate}`
    img.style.transition = 'transform 0.1s ease'
  }

  resetTilt = (event) => {
    const img = event.currentTarget

    // Reset tilt but preserve the animation translation
    img.dataset.tilt = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)'

    // const tilt = img.dataset.tilt || ''
    // const translate = img.dataset.translate || ''

    // img.style.transform = `${tilt} ${translate}`
    img.style.transition = 'transform 0.3s ease'
  }
}
